import { toast } from 'sonner'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { notifyError } from '@/components/notify'
import { isApiError } from '@/lib/api'
import type { Location } from '@/types/api'
import { useDeleteLocation } from '../api'

export function DeleteLocationDialog({ location, onOpenChange, onDeleted }: { location: Location | null; onOpenChange: (open: boolean) => void; onDeleted?: () => void }) {
  const del = useDeleteLocation()
  return (
    <ConfirmDialog
      open={!!location}
      onOpenChange={onOpenChange}
      destructive
      title={`Delete ${location?.name ?? 'location'}?`}
      description={
        location && location.displays_count > 0
          ? `This location still has ${location.displays_count} display${location.displays_count === 1 ? '' : 's'}. Move them to another location first.`
          : 'This permanently removes the location. This action can’t be undone.'
      }
      confirmLabel="Delete location"
      onConfirm={async () => {
        if (!location) return
        try {
          await del.mutateAsync(location.id)
          toast.success('Location deleted', { description: location.name })
          onDeleted?.()
        } catch (error) {
          if (isApiError(error) && error.status === 409) toast.error('Location has displays attached', { description: error.detail })
          else notifyError(error)
          throw error
        }
      }}
    />
  )
}
